import dayjs from "dayjs";
import { useForecastContext } from "../../../../../../context/forecastContext";
import SkeletonLoader from "../../../../../SkeletonLoader";
import ErrorMessage from "../../../../../errorMessage/errorMessage";
import { findForecastForDay } from "../../../../../../utilities/forecastHelpers";
import { Tooltip } from "@tag/tag-components-react-v4";
import { useTheme } from "../../../../../../context/themeContext";
import { PlusLined } from "@tag/tag-icons";
import "./weekDayRevenue.css";
import { useForecastQuery } from "../../../../../../services/forecastService";

type WeekDayRevenueProps = {
  day: dayjs.Dayjs;
};

const WeekDayRevenue: React.FC<WeekDayRevenueProps> = ({ day }) => {
  const { forecastState } = useForecastContext();
  const { theme } = useTheme();
  const {
    data: forecasts,
    isLoading,
    isError,
  } = useForecastQuery({
    mdrSiteId: forecastState.selectedSite?.mdrSiteId!,
    siteId: forecastState.selectedSite?.siteId!,
    orgId: forecastState.selectedSite?.organisationId!,
    searchPeriod: forecastState.searchPeriod,
  });

  if (isLoading) {
    return <SkeletonLoader />;
  }
  if (isError) {
    return <ErrorMessage dataType="Forecast" fontSize="11px" />;
  }

  const forecast = findForecastForDay(
    day.format("YYYY-MM-DD"),
    forecasts ?? []
  );

  if (!forecast) {
    return <>No Data</>;
  }

  return (
    <div className="week-day-revenue-container">
      <div className="week-day-revenue-header">
        <Tooltip
          background={theme}
          style={{
            borderRadius: "8px",
            border: "1px solid var(--border-color)",
          }}
          tooltipFor={<PlusLined accent="teal" style={{ cursor: "pointer" }} />}
        >
          <div className="week-day-site-event-popover-content">
            Add or edit revenue forecast
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default WeekDayRevenue;
